import { Component, OnInit } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { ElementDetailService } from './element-detail.service';
import { Element } from '../element';
import { MapsAPILoader, SebmGoogleMap } from 'angular2-google-maps/core';

@Component({
    selector: 'elementdetail',
    providers: [ElementDetailService],
    template: require('./element-detail.component.html'),

})

export class MainElementDetailComponent implements OnInit {

    router: Router;
    element: Element;
    idReceived: Number;
    tagsToShowInElement: Number;
    photosToShowInElement: Number;
    selectedPhotoUrl: string;
    classPhotoModal: any;
    userRole: string;
    userIsGuest: boolean;
    userIsSuperUser: boolean;
    userIsAdmin: boolean;
    classLoginModal: any;
    loginEmail: string;
    loginPassword: string;
    loginCode: number;

    classMessageModal: any;
    messageTitle: string;
    messageContent: string;
    messageCode: number;

    classUbicationModal: any;
    cityName: string;
    cityLatitude: number;
    cityLongitude: number;

    scroll: number;
    scrollHeight: number;
    elementsPage: number;
    categoryFilter: string;
    sellerFilter: string;
    citiesFilter: string;
    tagsFilter: string;

    days: any[] = [
        { id: 1, name: "MONDAY" },
        { id: 2, name: "TUESDAY" },
        { id: 3, name: "WEDNESDAY" },
        { id: 4, name: "THURSDAY" },
        { id: 5, name: "FRIDAY" },
        { id: 6, name: "SATURDAY" },
        { id: 7, name: "SUNDAY" }
    ];

    openLinks: boolean;
    openTags: boolean;
    openDays: boolean;
    openPhotos: boolean;
    openDescription: boolean;

    constructor(private _elementDetailService: ElementDetailService, _parentRouter: Router, private route: ActivatedRoute) {

        this.router = _parentRouter;        
        this.tagsToShowInElement = 6;
        this.photosToShowInElement = 3;
        this.selectedPhotoUrl = "";
        this.classPhotoModal = { 'model': true, 'show': false, 'hide': true };
        this.userRole = "guest";
        this.setUserRole(this.userRole);
        this.classLoginModal = { 'model': true, 'show': false, 'hide': true };
        this.loginEmail = "";
        this.loginPassword = "";
        this.loginCode = 0;

        this.classMessageModal = { 'model': true, 'show': false, 'hide': true };
        this.messageTitle = "";
        this.messageContent = "";
        this.messageCode = 0;

        this.classUbicationModal = { 'model': true, 'show': false, 'hide': true };
        this.cityName = "";
        this.cityLatitude = null;
        this.cityLongitude = null;

        this.openLinks = false;
        this.openTags = false;
        this.openDays = false;
        this.openPhotos = false;
        this.openDescription = false;
    }

    ngOnInit() {

        this._elementDetailService.getUserStatus().then(status => {
            this.userRole = status.role;
            this.setUserRole(this.userRole);

        });

        this.route.params.subscribe(params => {
            
            this.idReceived = Number(params['elementId']);
            this.scroll = Number(params['scroll']);
            this.scrollHeight = Number(params['scrollHeight']);
            this.elementsPage = Number(params['loadedPage']);
            this.categoryFilter = params['categoryType'];
            this.sellerFilter = params['sellerType'];
            this.citiesFilter = params['citiesFilter'];
            this.tagsFilter = params['tagsFilter'];

            this._elementDetailService.getElementsById(this.idReceived).then(result => {
                if (result != null) {
                    console.log(result);
                    var index: number;
                    for (index = 0; index < result.days.length; ++index) {
                        result.days[index].latitude = Number(result.days[index].latitude);
                        result.days[index].longitude = Number(result.days[index].longitude);
                    }

                    this.element = result;
                    this.element.tags_index = 0;
                    this.element.photos_index = 0;
                }
            });
        });

    }

    openLinksEvent() {
        this.openLinks = !this.openLinks;
    }

    openTagsEvent() {
        this.openTags = !this.openTags;
    }

    openDaysEvent() {
        this.openDays = !this.openDays;
    }

    openPhotosEvent() {
        this.openPhotos = !this.openPhotos;
    }

    openDescriptionEvent() {
        this.openDescription = !this.openDescription;
    }

    photoSelected(photoUrl: string) {
        this.selectedPhotoUrl = photoUrl;
        this.classPhotoModal.show = true;
        this.classPhotoModal.hide = false;
    }

    previousTagsClicked(element: Element) {
        element.tags_index--;
    }

    nextTagsClicked(element: Element) {
        element.tags_index++;
    }

    previousPhotosClicked(element: Element) {
        element.photos_index--;
    }

    nextPhotosClicked(element: Element) {
        element.photos_index++;
    }

    closePhotoModal() {
        this.classPhotoModal.show = false;
        this.classPhotoModal.hide = true;
    }

    closeLoginModal() {
        this.loginCode = 0;
        this.classLoginModal.show = false;
        this.classLoginModal.hide = true;
    }

    backClicked() {
        this.router.navigate(['/main', 'dashboard', { categoryType: this.categoryFilter, sellerType: this.sellerFilter, citiesFilter: this.citiesFilter, tagsFilter: this.tagsFilter, scroll: this.scroll, scrollHeight: this.scrollHeight, loadedPage: this.elementsPage }]);
    }

    setUserRole(userRole: string) {
        if (userRole == "guest") {
            this.userIsGuest = true;
            this.userIsSuperUser = false;
            this.userIsAdmin = false;
        } else if (userRole == "superuser") {
            this.userIsGuest = false;
            this.userIsSuperUser = true;
            this.userIsAdmin = false;
        } else if (userRole == "admin") {
            this.userIsGuest = false;
            this.userIsSuperUser = false;
            this.userIsAdmin = true;
        }

    }

    elementFavoriteClicked(element: Element) {

        if (this.userRole == "guest") {

            this.classLoginModal.show = true;
            this.classLoginModal.hide = false;

        } else if (this.userRole == "admin" || this.userRole == "superuser" || this.userRole == "user") {
            this._elementDetailService.manageFavorite(element.id).then(result => {
                if (result.code == 1) {
                    if (result.type == "insert") {
                        element.favorite = true;
                    } else {
                        element.favorite = false;
                    }
                }
            });
        }

    }

    elementMessageClicked(element: Element) {
        if (this.userRole == "guest") {
            this.classLoginModal.show = true;
            this.classLoginModal.hide = false;
        } else if (this.userRole == "admin" || this.userRole == "superuser" || this.userRole == "user") {
            this.classMessageModal.show = true;
            this.classMessageModal.hide = false;
        }
    }

    loginClicked() {

        this._elementDetailService.login(this.loginEmail, this.loginPassword).subscribe(result => {
            this.loginCode = result.code;
            if (result !== null && result.token !== undefined) {
                localStorage.setItem('userName', result.user.name);
                location.reload();
            }
        });

    }

    dayClicked(day: any) {
        console.log(day);
        this.cityName = day.city_name;
        console.log(this.cityName);
        this.cityLatitude = Number(day.latitude);
        console.log(this.cityLatitude);
        this.cityLongitude = Number(day.longitude);
        console.log(this.cityLongitude);
        if (this.days[day.id - 1].clicked) {
            this.days[day.id - 1].clicked = false;
        }
        else {
            this.days[day.id - 1].clicked = true;
        }
    }

    closeUbicationModal() {
        this.classUbicationModal.show = false;
        this.classUbicationModal.hide = true;
        this.cityName = "";
        this.cityLongitude = null;
        this.cityLatitude = null;
    }

    registerClicked() {

        this.router.navigate(['/register']);

    }

    closeMessageModal() {
        this.messageCode = 0;
        this.classMessageModal.show = false;
        this.classMessageModal.hide = true;
    }

    sendMessageClicked() {

        var titleIntroduced: boolean;
        if (this.messageTitle == null || this.messageTitle == undefined || this.messageTitle == "") {
            titleIntroduced = false;
        } else {
            titleIntroduced = true;
        }

        var contentIntroduced: boolean;
        if (this.messageContent == null || this.messageContent == undefined || this.messageContent == "") {
            contentIntroduced = false;
        } else {
            contentIntroduced = true;
        }

        if (!titleIntroduced && contentIntroduced) {
            this.messageCode = 1;
        } else if (titleIntroduced && !contentIntroduced) {
            this.messageCode = 2;
        } else if (!titleIntroduced && !contentIntroduced) {
            this.messageCode = 3;
        } else {
            this._elementDetailService.sendMessage(this.messageTitle, this.messageContent, this.element.user_id).then(res => {
                if (res.code == 1) {
                    this.closeMessageModal();
                }
            });
        }

    }

    private validateFacebookSite(facebook: string): string {
        if (facebook.indexOf("www.facebook.com") >= 0 || facebook.indexOf("www.facebook.es") >= 0) {
            var urlParams: string[] = facebook.split("/");
            var facebookUrl: string = "/";
            for (var i = 1; i < urlParams.length; i++) {
                facebookUrl += urlParams[i];
                if (i != urlParams.length - 1) {
                    facebookUrl += "/";
                }
            }
            return facebookUrl;
        } else {
            if (facebook.indexOf("/") != 0) {
                return "/" + facebook;
            } else {
                return facebook;
            }
        }
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/element_detail/element-detail.component.ts
 **/